import firebase from 'firebase/app'
import format from 'date-fns/format'
import router from '@/router'
import axios from 'axios'
import _ from 'lodash'
import { getByUser, getCompany } from '../core/cacheService'
export default {
  namespaced: true,
  state: {
    popupOpen: false,
    authData: null,
    autoLogin: true
  },
  mutations: {
    authData(state: any, authData: any) {
      state.authData = authData
    },
    popupOpen(state: any, popupOpen: boolean) {
      state.popupOpen = popupOpen
    },
    autoLogin(state: any, autoLogin: boolean) {
      state.autoLogin = autoLogin
    },
  },
  actions: {
    show({ commit, dispatch }: any, authData: any) {
      const company = _.get(authData, 'company', {});

      const ssoConfig = company.sso_configuration || {};
      const options = ssoConfig.options || [];
      const ssoOption = _.find(options, ['selected', true]);
      const enabled = _.get(ssoOption, 'enabled', false);
      if (!enabled) {
        console.log("SSO is not enabled");
        return;
      }

      const spEntityId = _.get(ssoOption, 'spEntityId', '');
      if (!spEntityId) {
        console.log("SSO Entity ID is not set");
        return;
      }

      const companyName = _.get(company, 'name', '');
      const email = String(_.get(authData, 'user.email', '')).toLowerCase();
      const loginSsoData = {
        email: email,
        company_name: companyName
      };
      
      // @see happily-reactnative/src/components/LoginForm.js
      firebase.database().ref('/loginsso')
      .push(loginSsoData)
      .then((res)=>{
        const key = res.key;
        const linkingUri = window.location.origin + "/sso-login/" + key;
  
        const accountsUrl = process.env.VUE_APP_ACCOUNTS_URL ||
          (window.location.hostname === 'localhost'
            ? 'http://localhost:8080'
            : 'https://accounts.happily.ai');
        const redirectUrl = `${accountsUrl}/sso/saml/${spEntityId}?id=${key}&linkingUri=${linkingUri}&type=saml-authenticate`;
        window.location.href = redirectUrl;
      });
    },
    async login({ commit, dispatch }: any, authData: any) {
      const { email } = authData;

      const emailKey = email.replace(/\./g, '||');
      const user = await getByUser(email)//(await firebase.database().ref(`/users/${emailKey}`).once('value')).val();

      if (user) {
        const company = await getCompany(user.company)
        const sso_configuration = company.sso_configuration || {};
        const options = sso_configuration.options || [];
        const selectedSso = _.find(options, ['selected', true]);
        const enabled = _.get(selectedSso, 'enabled', false);

        if (enabled) {
          
        }
      }
        
    },
    async loginByFirebase({ commit, dispatch }: any, authData: any) {
      const { email, providerId } = authData;
      const provider = new firebase.auth.SAMLAuthProvider(
        providerId
      );

      commit('popupOpen', true)
      await firebase
        .auth()
        .signInWithPopup(provider)
        // .signInWithRedirect(provider)
        .then(async (result: any) => {
          const targetEmail = result.user.email

        if(targetEmail){
          // @see src\store\core\authen.ts
          const emailKey = targetEmail.replace(/\./g, '||')
          var user = await getByUser(targetEmail)//(await firebase.database().ref(`/users/${emailKey}`).once('value')).val()
         }
          const company = await getCompany(user.company)
          const userData = {
            company_name: company.name,
            company: user.company,
            firstname: user.firstname,
            lastname: user.lastname,
            user_type: user.user_type,
            email: user.email,
            profilepic: (user.profilepic) ? user.profilepic : '',
            profilepic_crop: (user.profilepic_crop) ? user.profilepic_crop : '',
            profilepic_small: (user.profilepic_small) ? user.profilepic_small : ''
          }

          localStorage.setItem('userData', btoa(encodeURIComponent(JSON.stringify(userData))))

          localStorage.setItem('sso', 'Y')
          
          // Register account for multi-account switcher (for + email users)
          dispatch('accountSwitcher/registerAccount', {
            email: user.email,
            userData: userData,
            isSSO: true
          }, { root: true })
          
          // Clear the "adding account" flag if it was set
          localStorage.removeItem('addingAccount')


          // @todo use common function
          dispatch('authen/addLogs', {
            createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
            log_type: 'auth',
            event: 'login_success',
            status: 'login',
            result: 'success',
            reason: '',
            user: user.email,
            company: user.company,
            user_type: user.user_type,
            is_adviser: !!user.is_adviser,
            login_method: 'sso',
            redirect_to: user.user_type == 'admin' ? '/members' : '/',
          }, { root: true }).then(function () {
            setTimeout(() => {
              // commit('loadingStatus', false)

              // @fixed prevent error from many components
              // @todo  use route instead redirect
              // @see   router.replace('/')

              window.location.href = user.user_type == 'admin' ? '/members' : '/'

            }, 500);
          });

          // User is signed in.
          // Identity provider data available in result.additionalUserInfo.profile,
          // or from the user's ID token obtained from result.user.getIdToken()
          // as an object in the firebase.sign_in_attributes custom claim
          // This is also available from result.user.getIdTokenResult()
          // idTokenResult.claims.firebase.sign_in_attributes.
          /*

          console.group("signInWithPopup");
          const idToken = await result.user.getIdToken();
          const idTokenResult = await result.user.getIdTokenResult();
          console.log(result.user.getIdTokenResult().i.claims.firebase, 'result.user.getIdTokenResult().i.claims.firebase');
          console.groupEnd();
          //*/
          // localStorage.setItem("idToken", idToken);

        })
        .catch((error) => {
          // Handle error.
          console.log(error, "error")
        });

      commit('popupOpen', false)
      // console.log('after open')
    },

    async logout({ commit, dispatch }: any, authData: any) {

      // @todo implement Single Log Out (SLO)

      // const userData:any = localStorage.getItem('userData')
      // const user = JSON.parse(atob(userData))
      // console.log('logout()')
      // console.log(authData, 'authData')

      // @see https://developer.okta.com/docs/guides/sign-users-out/vue/main/#define-the-sign-out-callback
      /*
      const yourOktaDomain = 'happily.okta.com';
      const POST_LOGOUT_REDIRECT_URI = '/'
      const ISSUER = `https://${yourOktaDomain}/oauth2/default`

      const idToken = localStorage.getItem('idToken')
      console.log(ISSUER, 'ISSUER')
      const clientId = '0oagn4oh2kZ68Z776696'
      const signoutUrl = `${ISSUER}/v1/logout?client_id=${clientId}&id_token_hint=${idToken}&post_logout_redirect_uri=${POST_LOGOUT_REDIRECT_URI}`
      console.log(signoutUrl)
      //*/

      // it's work
      // https://happily.okta.com/login/signout?fromURI=http://localhost:8080/sso-logout

      /*
      const auth = firebase.auth()
      console.log(auth.currentUser, 'currentUser')
      if (auth.currentUser) {
        const token = await auth.currentUser.getIdToken()
        // console.log(token, 'token')
        const logoutUrl = 'https://67f6-2001-fb1-16-6a73-938-b228-f6a5-474e.ngrok.io/accounts/sso/logout'
        const res = await axios.get(logoutUrl, {
          headers: {
            'Authorization': 'Bearer ' + token
          }
        });
        console.log(res, 'res')
        console.log(res.data.redirectUrl, 'res.data.redirectUrl')

        // window.open(res.data.redirectUrl, '_blank')
      }
      //*/

      // @todo try to post to this page
      //const sloUrl = 'https://happily.okta.com/app/happily_linecorp_1/exkgn4oh1EcueRnN2696/slo/saml'
      /*
      axios.post(sloUrl, {
        withCredentials: true,
      })
        .then(function (response) {
          console.log(response, 'response')
        })
        .catch(function (error) {
          console.log(error, 'error')
        });
      //*/

      // return false

      localStorage.removeItem('sso')
      localStorage.removeItem('sso_email')
      localStorage.removeItem('sso_provider_id')
      localStorage.removeItem('sso_logout_url')
    },

    logoutCallback({ commit, dispatch }: any, ssoData: any) {
      console.log('logoutCallback()')
      console.log(ssoData, 'ssoData')

      document.body.innerHTML = format(new Date(), 'YYYY-MM-DD HH:mm:ss')


      return;
      dispatch('authen/addLogs', {
        createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
        status: 'sso.logout',
        user: ssoData.email
      }, { root: true }).then(function () {
        // firebase.auth().signOut()

        // localStorage.removeItem('userData')
        // commit('setUserLogin', null)

        // router.replace('/login')
      });
    }
  },
  getters: {
    authData: (state: any) => {
      return state.authData
    },
    autoLogin: (state: any) => {
      return state.autoLogin
    },
    popupOpen: (state: any) => {
      return state.popupOpen
    }
  }
}
